import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const TASKS_URLS: generalConst = {
  BASE_URL: ROUTES.TASKS,
  TASK_REQUEST_DETAIL: `${ROUTES.TASKS}/TasklDetail`,
};

export enum TaskoperationType {
  NULL = "NULL",
  EXECUTE = "EXECUTE",
  UNEXECUTE = "UNEXECUTE",
}

export const TASKS_REQUEST_FORM_FILTER = "TasksFormFilter";

export const TASK_LIST_IDENTIFIER = "taskList";
export const CSV_TASK_LIST_IDENTIFIER = "csvTaskList";
export const CSV_TASK_LOADED_IDENTIFIER = "csvTaskLoaded";
export const TASK_LIST_LOADER = "taskListLoader";

export const SELECTED_TASK_IDENTIFIER = "selectedTask";

export const TASK_DETAIL_IDENTIFIER = "selectTaskDetail";
export const TASK_DETAIL_LOADER_IDENTIFIER = "selectTaskDetailLoader";

export const TASK_MAIN_CALL_STATE = "taskMainCallState";

export const TAKE_CHARGE_TASK_CALL_STATE = "takeChargeTaskCallState";
export const SELECTED_AGGREGATE_TASK = "selectedAggregateTask";
export const CANCEL_TAKE_CHARGE_TASK_CALL_STATE =
  "cancelTakeChargeTaskCallState";

export const ATTACHMENT_CALL_STATE_IDENTIFIER = "attachmentCallStateIdentifier";

export const ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE =
  "attachmentCallStateIdentifierSave";

export const SELECTED_TASK_TMP_ATTRIBUTES = "selectedTaskTmpAttributes";

export const mockTaskDetailObjectMODIFICA_ACCOUNT = {
  taskKey: {
    codeOperation: "PM_7834606028099253763_3291",
    userId: "OU00506",
    application: "Barra Telefonica",
    action: null,
    createdOn: null,
    taskBeneficiaryInfo: null,
  },
  taskDetails: [
    {
      task_id: "259923",
      cod_operation: "PM_7834606028099253763_3291",
      user_id: "OU00506",
      application: "Barra Telefonica",
      action: "10",
      provisioning: "azzolim",
      description: null,
      bao_code: null,
      bao_fullname: "",
      state: null,
      erc_status: null,
      account_id: "azzolim",
      details: {
        remoteAttributes: {
          "@remote_erNexiGenericApplicationAccCompany": [
            {
              oldValue: null,
              newValue: null,
            },
          ],
          "@remote_erNexiGenericApplicationAccOwnerCF": [
            {
              oldValue: null,
              newValue: null,
            },
          ],
          "@remote_erNexiGenericApplicationAccOwnerSurname": [
            {
              oldValue: null,
              newValue: null,
            },
          ],
          "@remote_erNexiGenericApplicationAccOwnerID": [
            {
              oldValue: null,
              newValue: null,
            },
          ],
          "@remote_erNexiGenericApplicationAccOwnerMail": [
            {
              oldValue: null,
              newValue: null,
            },
          ],
          "@remote_erNexiGenericApplicationAccProfiles": [
            {
              oldValue: null,
              newValue: null,
            },
          ],
          "@remote_erNexiGenericApplicationAccLastReconTime": [
            {
              oldValue: null,
              newValue: null,
            },
          ],
          "@remote_erNexiGenericApplicationAccOwnerName": [
            {
              oldValue: null,
              newValue: null,
            },
          ],
        },
        fixedAttributes: {
          "@fixed_name": {
            oldValue: "Maria Gloria",
            newValue: "Maria Gloria",
          },
          "@fixed_last_access_date": {
            oldValue: null,
            newValue: null,
          },
          "@fixed_display_name": {
            oldValue: null,
            newValue: "",
          },
          "@fixed_code": {
            oldValue: "ou00506",
            newValue: "azzolim",
          },
          "@fixed_last_wrong_login": {
            oldValue: null,
            newValue: null,
          },
          "@fixed_dn": {
            oldValue: null,
            newValue: "",
          },
          "@fixed_email": {
            oldValue: null,
            newValue: "",
          },
          "@fixed_isDefault": {
            oldValue: "1",
            newValue: "1",
          },
          "@fixed_accountType_name": {
            oldValue: null,
            newValue: null,
          },
          "@fixed_expire": {
            oldValue: null,
            newValue: null,
          },
          "@fixed_surname": {
            oldValue: "Azzoli",
            newValue: "Azzoli",
          },
          "@fixed_last_pwd_change": {
            oldValue: "1612013096000",
            newValue: "1612013096000",
          },
          "@fixed_number_login_error": {
            oldValue: "0",
            newValue: "0",
          },
        },
      },
      enrichment: null,
    },
  ],
};
